'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_DocumentAuditLogAction$namedEnum$() {
  this.aAB = null;
  this.aAC = null;
  this.aAD = false;
  $n_Lapp_data_DocumentAuditLogAction$namedEnum$ = this;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NamedEnum__$init$__V(this);
}
export { $c_Lapp_data_DocumentAuditLogAction$namedEnum$ as $c_Lapp_data_DocumentAuditLogAction$namedEnum$ };
$p = $c_Lapp_data_DocumentAuditLogAction$namedEnum$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_DocumentAuditLogAction$namedEnum$;
/** @constructor */
function $h_Lapp_data_DocumentAuditLogAction$namedEnum$() {
}
export { $h_Lapp_data_DocumentAuditLogAction$namedEnum$ as $h_Lapp_data_DocumentAuditLogAction$namedEnum$ };
$h_Lapp_data_DocumentAuditLogAction$namedEnum$.prototype = $p;
$p.IK = (function() {
  return this.aAB;
});
$p.VV = (function(x$0) {
  this.aAB = x$0;
});
$p.bY2 = (function(a) {
  var x = $s_Lapp_data_DocumentAuditLogAction$__View__Lapp_data_DocumentAuditLogAction();
  if ((x === a)) {
    return "view";
  }
  var x$3 = $s_Lapp_data_DocumentAuditLogAction$__DownloadJson__Lapp_data_DocumentAuditLogAction();
  if ((x$3 === a)) {
    return "download_json";
  }
  var x$5 = $s_Lapp_data_DocumentAuditLogAction$__DownloadPdf__Lapp_data_DocumentAuditLogAction();
  if ((x$5 === a)) {
    return "download_pdf";
  }
  var x$7 = $s_Lapp_data_DocumentAuditLogAction$__Created__Lapp_data_DocumentAuditLogAction();
  if ((x$7 === a)) {
    return "created";
  }
  var x$9 = $s_Lapp_data_DocumentAuditLogAction$__RelatedDocumentCreated__Lapp_data_DocumentAuditLogAction();
  if ((x$9 === a)) {
    return "related_document_created";
  }
  var x$11 = $s_Lapp_data_DocumentAuditLogAction$__NewVersionCreated__Lapp_data_DocumentAuditLogAction();
  if ((x$11 === a)) {
    return "new_version_created";
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(a);
});
$p.wy = (function() {
  if ((!this.aAD)) {
    var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().fw($m_Lapp_data_DocumentAuditLogAction$().bZz());
    this.aAC = $x_1.E4($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().aO(this$2));
    this.aAD = true;
  }
  return this.aAC;
});
$p.yN = (function(a) {
  return this.bY2(a);
});
var $d_Lapp_data_DocumentAuditLogAction$namedEnum$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_DocumentAuditLogAction$namedEnum$, "app.data.DocumentAuditLogAction$namedEnum$", ({
  Db: 1,
  da: 1
}));
export { $d_Lapp_data_DocumentAuditLogAction$namedEnum$ as $d_Lapp_data_DocumentAuditLogAction$namedEnum$ };
var $n_Lapp_data_DocumentAuditLogAction$namedEnum$;
function $m_Lapp_data_DocumentAuditLogAction$namedEnum$() {
  if ((!$n_Lapp_data_DocumentAuditLogAction$namedEnum$)) {
    $n_Lapp_data_DocumentAuditLogAction$namedEnum$ = new $c_Lapp_data_DocumentAuditLogAction$namedEnum$();
  }
  return $n_Lapp_data_DocumentAuditLogAction$namedEnum$;
}
export { $m_Lapp_data_DocumentAuditLogAction$namedEnum$ as $m_Lapp_data_DocumentAuditLogAction$namedEnum$ };
function $s_Lapp_data_DocumentAuditLogAction$__View__Lapp_data_DocumentAuditLogAction() {
  $m_Lapp_data_DocumentAuditLogAction$();
  return $t_Lapp_data_DocumentAuditLogAction$__View;
}
export { $s_Lapp_data_DocumentAuditLogAction$__View__Lapp_data_DocumentAuditLogAction as $s_Lapp_data_DocumentAuditLogAction$__View__Lapp_data_DocumentAuditLogAction };
function $s_Lapp_data_DocumentAuditLogAction$__DownloadJson__Lapp_data_DocumentAuditLogAction() {
  $m_Lapp_data_DocumentAuditLogAction$();
  return $t_Lapp_data_DocumentAuditLogAction$__DownloadJson;
}
export { $s_Lapp_data_DocumentAuditLogAction$__DownloadJson__Lapp_data_DocumentAuditLogAction as $s_Lapp_data_DocumentAuditLogAction$__DownloadJson__Lapp_data_DocumentAuditLogAction };
function $s_Lapp_data_DocumentAuditLogAction$__DownloadPdf__Lapp_data_DocumentAuditLogAction() {
  $m_Lapp_data_DocumentAuditLogAction$();
  return $t_Lapp_data_DocumentAuditLogAction$__DownloadPdf;
}
export { $s_Lapp_data_DocumentAuditLogAction$__DownloadPdf__Lapp_data_DocumentAuditLogAction as $s_Lapp_data_DocumentAuditLogAction$__DownloadPdf__Lapp_data_DocumentAuditLogAction };
function $s_Lapp_data_DocumentAuditLogAction$__Created__Lapp_data_DocumentAuditLogAction() {
  $m_Lapp_data_DocumentAuditLogAction$();
  return $t_Lapp_data_DocumentAuditLogAction$__Created;
}
export { $s_Lapp_data_DocumentAuditLogAction$__Created__Lapp_data_DocumentAuditLogAction as $s_Lapp_data_DocumentAuditLogAction$__Created__Lapp_data_DocumentAuditLogAction };
function $s_Lapp_data_DocumentAuditLogAction$__RelatedDocumentCreated__Lapp_data_DocumentAuditLogAction() {
  $m_Lapp_data_DocumentAuditLogAction$();
  return $t_Lapp_data_DocumentAuditLogAction$__RelatedDocumentCreated;
}
export { $s_Lapp_data_DocumentAuditLogAction$__RelatedDocumentCreated__Lapp_data_DocumentAuditLogAction as $s_Lapp_data_DocumentAuditLogAction$__RelatedDocumentCreated__Lapp_data_DocumentAuditLogAction };
function $s_Lapp_data_DocumentAuditLogAction$__NewVersionCreated__Lapp_data_DocumentAuditLogAction() {
  $m_Lapp_data_DocumentAuditLogAction$();
  return $t_Lapp_data_DocumentAuditLogAction$__NewVersionCreated;
}
export { $s_Lapp_data_DocumentAuditLogAction$__NewVersionCreated__Lapp_data_DocumentAuditLogAction as $s_Lapp_data_DocumentAuditLogAction$__NewVersionCreated__Lapp_data_DocumentAuditLogAction };
/** @constructor */
function $c_Lapp_data_DocumentAuditLogAction$() {
  this.aAw = null;
  this.aAx = null;
  this.aAy = false;
  this.aAz = null;
  this.aAA = false;
  $n_Lapp_data_DocumentAuditLogAction$ = this;
  $t_Lapp_data_DocumentAuditLogAction$__View = new $c_Lapp_data_DocumentAuditLogAction$$anon$1("View", 0);
  $t_Lapp_data_DocumentAuditLogAction$__DownloadJson = new $c_Lapp_data_DocumentAuditLogAction$$anon$1("DownloadJson", 1);
  $t_Lapp_data_DocumentAuditLogAction$__DownloadPdf = new $c_Lapp_data_DocumentAuditLogAction$$anon$1("DownloadPdf", 2);
  $t_Lapp_data_DocumentAuditLogAction$__Created = new $c_Lapp_data_DocumentAuditLogAction$$anon$1("Created", 3);
  $t_Lapp_data_DocumentAuditLogAction$__RelatedDocumentCreated = new $c_Lapp_data_DocumentAuditLogAction$$anon$1("RelatedDocumentCreated", 4);
  $t_Lapp_data_DocumentAuditLogAction$__NewVersionCreated = new $c_Lapp_data_DocumentAuditLogAction$$anon$1("NewVersionCreated", 5);
  this.aAw = new ($d_Lapp_data_DocumentAuditLogAction.r().C)([$s_Lapp_data_DocumentAuditLogAction$__View__Lapp_data_DocumentAuditLogAction(), $s_Lapp_data_DocumentAuditLogAction$__DownloadJson__Lapp_data_DocumentAuditLogAction(), $s_Lapp_data_DocumentAuditLogAction$__DownloadPdf__Lapp_data_DocumentAuditLogAction(), $s_Lapp_data_DocumentAuditLogAction$__Created__Lapp_data_DocumentAuditLogAction(), $s_Lapp_data_DocumentAuditLogAction$__RelatedDocumentCreated__Lapp_data_DocumentAuditLogAction(), $s_Lapp_data_DocumentAuditLogAction$__NewVersionCreated__Lapp_data_DocumentAuditLogAction()]);
}
export { $c_Lapp_data_DocumentAuditLogAction$ as $c_Lapp_data_DocumentAuditLogAction$ };
$p = $c_Lapp_data_DocumentAuditLogAction$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_DocumentAuditLogAction$;
/** @constructor */
function $h_Lapp_data_DocumentAuditLogAction$() {
}
export { $h_Lapp_data_DocumentAuditLogAction$ as $h_Lapp_data_DocumentAuditLogAction$ };
$h_Lapp_data_DocumentAuditLogAction$.prototype = $p;
$p.bZz = (function() {
  return this.aAw.aS();
});
$p.aC = (function() {
  if ((!this.aAy)) {
    this.aAx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NamedEnum__circeCodec__Lio_circe_Codec($m_Lapp_data_DocumentAuditLogAction$namedEnum$());
    this.aAy = true;
  }
  return this.aAx;
});
$p.fI = (function() {
  if ((!this.aAA)) {
    this.aAz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NamedEnum__tapirCodec__Lsttp_tapir_Codec($m_Lapp_data_DocumentAuditLogAction$namedEnum$());
    this.aAA = true;
  }
  return this.aAz;
});
$p.dl = (function(x) {
  return x.ahA;
});
var $d_Lapp_data_DocumentAuditLogAction$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_DocumentAuditLogAction$, "app.data.DocumentAuditLogAction$", ({
  D9: 1,
  d: 1,
  D: 1
}));
export { $d_Lapp_data_DocumentAuditLogAction$ as $d_Lapp_data_DocumentAuditLogAction$ };
var $n_Lapp_data_DocumentAuditLogAction$;
function $m_Lapp_data_DocumentAuditLogAction$() {
  if ((!$n_Lapp_data_DocumentAuditLogAction$)) {
    $n_Lapp_data_DocumentAuditLogAction$ = new $c_Lapp_data_DocumentAuditLogAction$();
  }
  return $n_Lapp_data_DocumentAuditLogAction$;
}
export { $m_Lapp_data_DocumentAuditLogAction$ as $m_Lapp_data_DocumentAuditLogAction$ };
/** @constructor */
function $c_Lapp_data_DocumentAuditLogAction() {
}
export { $c_Lapp_data_DocumentAuditLogAction as $c_Lapp_data_DocumentAuditLogAction };
$p = $c_Lapp_data_DocumentAuditLogAction.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_DocumentAuditLogAction;
/** @constructor */
function $h_Lapp_data_DocumentAuditLogAction() {
}
export { $h_Lapp_data_DocumentAuditLogAction as $h_Lapp_data_DocumentAuditLogAction };
$h_Lapp_data_DocumentAuditLogAction.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.hJ = (function(locale) {
  var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
  if ((x === locale)) {
    var x$3 = $s_Lapp_data_DocumentAuditLogAction$__View__Lapp_data_DocumentAuditLogAction();
    if (((x$3 !== null) && (x$3 === this))) {
      return "View";
    }
    var x$5 = $s_Lapp_data_DocumentAuditLogAction$__DownloadJson__Lapp_data_DocumentAuditLogAction();
    if (((x$5 !== null) && (x$5 === this))) {
      return "Download JSON";
    }
    var x$7 = $s_Lapp_data_DocumentAuditLogAction$__DownloadPdf__Lapp_data_DocumentAuditLogAction();
    if (((x$7 !== null) && (x$7 === this))) {
      return "Download PDF";
    }
    var x$9 = $s_Lapp_data_DocumentAuditLogAction$__Created__Lapp_data_DocumentAuditLogAction();
    if (((x$9 !== null) && (x$9 === this))) {
      return "Created";
    }
    var x$11 = $s_Lapp_data_DocumentAuditLogAction$__RelatedDocumentCreated__Lapp_data_DocumentAuditLogAction();
    if (((x$11 !== null) && (x$11 === this))) {
      return "Related document created";
    }
    var x$13 = $s_Lapp_data_DocumentAuditLogAction$__NewVersionCreated__Lapp_data_DocumentAuditLogAction();
    if (((x$13 !== null) && (x$13 === this))) {
      return "New version created";
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(locale);
});
var $d_Lapp_data_DocumentAuditLogAction = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i(0, "app.data.DocumentAuditLogAction", ({
  jl: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_DocumentAuditLogAction as $d_Lapp_data_DocumentAuditLogAction };
/** @constructor */
function $c_Lapp_data_DocumentAuditLogAction$$anon$1(\u03b4name$3, _$ordinal$3) {
  this.ahz = null;
  this.ahA = 0;
  this.ahz = \u03b4name$3;
  this.ahA = _$ordinal$3;
}
export { $c_Lapp_data_DocumentAuditLogAction$$anon$1 as $c_Lapp_data_DocumentAuditLogAction$$anon$1 };
$p = $c_Lapp_data_DocumentAuditLogAction$$anon$1.prototype = new $h_Lapp_data_DocumentAuditLogAction();
$p.constructor = $c_Lapp_data_DocumentAuditLogAction$$anon$1;
/** @constructor */
function $h_Lapp_data_DocumentAuditLogAction$$anon$1() {
}
export { $h_Lapp_data_DocumentAuditLogAction$$anon$1 as $h_Lapp_data_DocumentAuditLogAction$$anon$1 };
$h_Lapp_data_DocumentAuditLogAction$$anon$1.prototype = $p;
$p.s = (function() {
  return 0;
});
$p.e = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.u = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.t = (function() {
  return this.ahz;
});
$p.n = (function() {
  return this.ahz;
});
$p.co = (function() {
  return this.ahA;
});
$p.U = (function(p) {
  return this;
});
var $d_Lapp_data_DocumentAuditLogAction$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_DocumentAuditLogAction$$anon$1, "app.data.DocumentAuditLogAction$$anon$1", ({
  Da: 1,
  jl: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  r: 1,
  d: 1,
  e: 1,
  k: 1
}));
export { $d_Lapp_data_DocumentAuditLogAction$$anon$1 as $d_Lapp_data_DocumentAuditLogAction$$anon$1 };
var $t_Lapp_data_DocumentAuditLogAction$__View = null;
function $u_Lapp_data_DocumentAuditLogAction$__View(x) {
  $t_Lapp_data_DocumentAuditLogAction$__View = x;
}
export { $t_Lapp_data_DocumentAuditLogAction$__View as $t_Lapp_data_DocumentAuditLogAction$__View, $u_Lapp_data_DocumentAuditLogAction$__View as $u_Lapp_data_DocumentAuditLogAction$__View };
var $t_Lapp_data_DocumentAuditLogAction$__DownloadJson = null;
function $u_Lapp_data_DocumentAuditLogAction$__DownloadJson(x) {
  $t_Lapp_data_DocumentAuditLogAction$__DownloadJson = x;
}
export { $t_Lapp_data_DocumentAuditLogAction$__DownloadJson as $t_Lapp_data_DocumentAuditLogAction$__DownloadJson, $u_Lapp_data_DocumentAuditLogAction$__DownloadJson as $u_Lapp_data_DocumentAuditLogAction$__DownloadJson };
var $t_Lapp_data_DocumentAuditLogAction$__DownloadPdf = null;
function $u_Lapp_data_DocumentAuditLogAction$__DownloadPdf(x) {
  $t_Lapp_data_DocumentAuditLogAction$__DownloadPdf = x;
}
export { $t_Lapp_data_DocumentAuditLogAction$__DownloadPdf as $t_Lapp_data_DocumentAuditLogAction$__DownloadPdf, $u_Lapp_data_DocumentAuditLogAction$__DownloadPdf as $u_Lapp_data_DocumentAuditLogAction$__DownloadPdf };
var $t_Lapp_data_DocumentAuditLogAction$__Created = null;
function $u_Lapp_data_DocumentAuditLogAction$__Created(x) {
  $t_Lapp_data_DocumentAuditLogAction$__Created = x;
}
export { $t_Lapp_data_DocumentAuditLogAction$__Created as $t_Lapp_data_DocumentAuditLogAction$__Created, $u_Lapp_data_DocumentAuditLogAction$__Created as $u_Lapp_data_DocumentAuditLogAction$__Created };
var $t_Lapp_data_DocumentAuditLogAction$__RelatedDocumentCreated = null;
function $u_Lapp_data_DocumentAuditLogAction$__RelatedDocumentCreated(x) {
  $t_Lapp_data_DocumentAuditLogAction$__RelatedDocumentCreated = x;
}
export { $t_Lapp_data_DocumentAuditLogAction$__RelatedDocumentCreated as $t_Lapp_data_DocumentAuditLogAction$__RelatedDocumentCreated, $u_Lapp_data_DocumentAuditLogAction$__RelatedDocumentCreated as $u_Lapp_data_DocumentAuditLogAction$__RelatedDocumentCreated };
var $t_Lapp_data_DocumentAuditLogAction$__NewVersionCreated = null;
function $u_Lapp_data_DocumentAuditLogAction$__NewVersionCreated(x) {
  $t_Lapp_data_DocumentAuditLogAction$__NewVersionCreated = x;
}
export { $t_Lapp_data_DocumentAuditLogAction$__NewVersionCreated as $t_Lapp_data_DocumentAuditLogAction$__NewVersionCreated, $u_Lapp_data_DocumentAuditLogAction$__NewVersionCreated as $u_Lapp_data_DocumentAuditLogAction$__NewVersionCreated };
//# sourceMappingURL=app.data.-Document-Audit-Log-Action.js.map
